export default function IosCogOutline() {
  return (
    <div
      className="ion-icon-ios-cog-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M448,272.754v-32.008l-33.291-8.703l-2.601-13.204l27.594-20.905l-12.197-29.608l-34.392,4.802l-7.498-10.603
		l17.696-29.708l-22.594-22.605l-30.192,17.404l-10.697-7.302l5.298-35.009l-29.492-12.303L294.04,101.31l-12.297-2.601L273.045,64
		h-31.991l-9.197,34.909l-12.098,2.4l-21.494-29.008l-29.592,12.304l4.799,35.709l-11.697,7.202l-31.292-18.705l-22.594,22.606
		l18.795,31.508l-6.698,10.502l-35.49-5.001l-12.197,29.608l28.893,21.706l-2.399,12.203L64,240.846v32.008l34.69,8.903l2.4,12.503
		l-28.394,21.306l12.297,29.508l34.991-5.002l7.099,11.303l-17.896,30.608l22.595,22.605l30.192-18.204l11.196,7.302l-4.498,34.31
		l29.592,12.202l20.595-27.807l13.396,2.5L241.054,448h31.991l8.298-33.109l13.597-2.601l20.694,27.107l29.593-12.204l-4.998-33.708
		l10.196-7.401l28.992,16.904l22.595-22.606l-16.795-28.907l7.896-11.403l33.791,4.802l12.298-29.508l-27.193-20.506l2.7-13.503
		L448,272.754z M419.707,320.767l-2.8,6.702l-31.891-4.501l-18.896,27.807l15.695,27.106l-5.198,5.202l-27.293-15.904
		l-26.593,18.204l4.799,31.809l-6.698,2.802l-19.595-25.607l-32.892,6.501l-7.798,31.209h-7.198l-8.397-31.309l-32.592-6.501
		l-19.495,26.406l-6.698-2.801l4.399-32.509l-27.493-18.304l-28.793,17.504l-5.099-5.101l16.996-29.108l-18.096-27.606
		l-33.191,4.701l-2.699-6.603l26.894-20.205l-6.199-31.809l-32.991-8.502v-7.202l32.991-8.402l6.299-31.608l-27.293-20.505
		l2.699-6.602l33.691,4.801l17.796-26.807l-17.996-30.008l4.999-5.001l20.595,12.303l9.197,5.501l27.893-18.205l-4.499-33.809
		l6.699-2.8l20.294,27.407l31.492-6.102l8.798-33.208h7.198l8.298,33.008l31.691,6.301l20.095-26.807l6.598,2.801l-4.999,33.108
		l27.193,18.105l28.292-16.205l5.1,5.102l-16.695,28.007l18.396,27.007l32.491-4.601l2.799,6.702l-26.193,19.705l6.498,32.508
		l31.292,8.102v7.202l-31.391,8.103l-6.499,32.709L419.707,320.767z"/>
	<path d="M256,128c-70.692,0-128,57.308-128,128c0,70.693,57.308,128,128,128s128-57.307,128-128C384,185.308,326.692,128,256,128z
		 M144,256c0-29.916,11.65-58.042,32.804-79.195C197.958,155.65,226.084,144,256,144c7.496,0,14.88,0.732,22.069,2.161L250.3,250.1
		l-104.155,27.888C144.727,270.824,144,263.468,144,256z M256,368c-29.917,0-58.042-11.65-79.196-32.804
		c-11.927-11.926-20.831-26.069-26.331-41.499L253.9,266.2l74.935,74.889C308.558,358.501,283.009,368,256,368z M340.154,329.901
		L265.2,254.9l28.05-104.58c15.604,5.487,29.904,14.443,41.945,26.484C356.35,197.958,368,226.084,368,256
		C368,283.486,358.159,309.457,340.154,329.901z"/>
</g>
</svg>
`,
      }}
    />
  )
}
